import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import { getControlField } from "../../../../Services/tooltipService";
import { getCustomerFields } from "../../../../Services/fieldsServices";
import DataTable from "../../../../Components/UiComponents/DataTable";
import { ColorPicker } from 'primereact/colorpicker';
import { Dialog } from "primereact/dialog";
import FileUploader from "./fileUploader";
import { updateColor, updateStage, getLogo } from "../../../../Services/customerServices";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
import { retunToDefaultLogo } from "../../../../Services/customerServices";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";

const Setup = (props) => {
	const [customerId, setCustomerId] = useState(null);
	const [stage, setStage] = useState([]);
	const [referenceData, setReferenceData] = useState([]);
	const [color, setColor] = useState(null);
	const [fileName, setFileName] = useState(null);
	const [uploadPopup, setUploadPopup] = useState(false);
	const [newStageData, setNewStageData] = useState(false);
	const [loading, setLoading] = useState(false);
	const [controlPanelTabs, setControlPanelTabs] = useState({});
	const [controlSetHeaders, setControlSetHeaders] = useState([]);
	const [colorDetails, setColorDetails] = useState('#19486B');
	const [showVideo, setShowVideo] = useState(false);
	const navigate = useNavigate()

	const toastRef = useRef()

	useEffect(() => {
		const customerData = localStorage.getItem("enduser");
		if (customerData) {
			const customerDataInJSON = JSON.parse(customerData);
			setCustomerId(customerDataInJSON.customer);
		} else {
			navigate("/login")
			localStorage.clear()
		}
	}, []);

	useEffect(() => {
		if (customerId) {
			getCustomer();
			getControlFieldData()
			getLogoColorDetails()
		}
	}, [customerId]);

	const getLogoColorDetails = async () => {
		try {
			if (customerId === null) {
				toastRef.current.showToast({
					type: 'error',
					message: 'Missing customer ID'
				});
				return;
			}
			var data = await getLogo(customerId)
			if (data && data.data) {
				setColor(data.data.fileLocation.backgroundColor)
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or Contact Admin.'
			});
		}
	}

	const getControlFieldData = async () => {
		try {
			if (customerId === null) {
				toastRef.current.showToast({
					type: 'error',
					message: 'Missing customer ID'
				});
				return;
			}
			var clientModuleData = await getControlField(customerId)
			var controlPanelModules = _.find(clientModuleData?.data.cust[0].modules, { module_name: "Control Panel", status: true });
			var controlPanelTabs = _.find(controlPanelModules.tabs, { tab_name: "Setup", status: true });
			setControlPanelTabs(controlPanelTabs)
			var cntlPannel_Setup = _.find(controlPanelModules.tabs, { tab_name: "Setup" }).tables;
			var cntlPannelSetupHeaders = _.find(cntlPannel_Setup, { table_name: "Setup" }).headers;
			setControlSetHeaders(cntlPannelSetupHeaders)
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or Contact Admin.'
			});
		}
	}

	const getCustomer = async () => {
		try {
			if (customerId === null) {
				toastRef.current.showToast({
					type: 'error',
					message: 'Missing customer ID'
				});
				return;
			}
			if (customerId !== null) {
				const response = await getCustomerFields(customerId);
				let data = response?.data?.reference_data
				setReferenceData(data)
				let stage = data.filter(item => item.option_names === 'WinWorkStage')
				const updatedData = stage[0].option_choice.map(item => {
					if (item.label === 'Target') {
						return {
							...item,
							label: 'Assess & Strategise'
						};
					}
					if (item.label === 'Pursuit') {
						return {
							...item,
							label: 'Objectives & Budget'
						};
					}
					if (item.label === 'Pre-Qualify') {
						return {
							...item,
							label: 'Risks & Opportunities'
						};
					}
					if (item.label === 'Submission') {
						return {
							...item,
							label: 'Targets & Activities'
						};
					}
					if (item.label === 'Appointment') {
						return {
							...item,
							label: 'Project Start'
						};
					}
					if (item.label === 'Deliver') {
						return {
							...item,
							label: 'Monitor & Evaluate'
						};
					}
					if (item.label === 'Feedback') {
						return {
							...item,
							label: 'Report & Feedback'
						};
					}

					return item; // Return the item unchanged if no match
				});
				setStage(updatedData)
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or Contact Admin.'
			});
		}
	}

	const onCloseUploadPopup = () => {
		setUploadPopup(false);
	};

	const handleSave = (data) => {
		setFileName(data)
		props.newLogo(true)
		setUploadPopup(false);
	}

	const setData = () => {
		setUploadPopup(true);
	};

	const handleUpload = async () => {
		try {
			if (customerId === null) {
				toastRef.current.showToast({
					type: 'error',
					message: 'Missing customer ID'
				});
				return;
			}
			setLoading(true)
			if (color) {
				const colorResponse = await updateColor(customerId, color);
				if (colorResponse && colorResponse.data) {
					toastRef.current.showToast({
						type: 'success',
						message: "Color Uploaded Successfully"
					});
				}
				setFileName('')
				setColor('')
				getLogoColorDetails()
			} else {
				setFileName('')
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or Contact Admin.'
			});
		} finally {
			setLoading(false)
		}
	};

	const handlereturnToDefault = async () => {
		try {
			if (customerId === null) {
				toastRef.current.showToast({
					type: 'error',
					message: 'Missing customer ID'
				});
				return;
			}
			setLoading(true)
			// Upload company logo
			const defaultResponse = await retunToDefaultLogo(customerId);

			// Handle the response
			if (defaultResponse && defaultResponse.data) {
				toastRef.current.showToast({
					type: 'success',
					message: "Logo Updated Successfully"
				});
			}
			props.newLogo(true)
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or Contact Admin.'
			});
		} finally {
			setLoading(false)
		}
	};

	const textEditor = (rowData) => {
		return <InputTextElementElement
			type="text"
			value={rowData.rowData.text}
			onChange={(e) => rowData.editorCallback(e.target.value)}
		/>;
	};

	const columns = [
		{
			field: "label",
			header: "Stage Label",
			headerClassName: "header-datatable white-space",
			className: 'row-datatable',
			style: { width: '30%' }
		},
		{
			field: "text",
			header: "Stage Text",
			headerClassName: "header-datatable white-space",
			className: 'row-datatable',
			editor: textEditor,
			style: { width: '30%' }
		}
	]

	const rowEditClick = (data) => {
		setNewStageData(true);
		const updatedStage = stage.map(item =>
			item.label === data.label ? data : item
		);
		setStage(updatedStage);
	}

	const saveStages = async () => {
		try {
			if (customerId === null) {
				toastRef.current.showToast({
					type: 'error',
					message: 'Missing customer ID'
				});
				return;
			}
			setLoading(true)
			const updatedData = stage.map(item => {
				if (item.label === 'Assess & Strategise') {
					return {
						...item,
						label: 'Target'
					};
				}
				if (item.label === 'Objectives & Budget') {
					return {
						...item,
						label: 'Pursuit'
					};
				}
				if (item.label === 'Risks & Opportunities') {
					return {
						...item,
						label: 'Pre-Qualify'
					};
				}
				if (item.label === 'Targets & Activities') {
					return {
						...item,
						label: 'Submission'
					};
				}
				if (item.label === 'Project Start') {
					return {
						...item,
						label: 'Appointment'
					};
				}
				if (item.label === 'Monitor & Evaluate') {
					return {
						...item,
						label: 'Deliver'
					};
				}
				if (item.label === 'Report & Feedback') {
					return {
						...item,
						label: 'Feedback'
					};
				}

				return item; // Return the item unchanged if no match
			});
			const updatedReferenceData = referenceData.map(item => {
				if (item.option_names === 'WinWorkStage') {
					return {
						...item,
						option_choice: updatedData
					};
				}
				return item;
			});

			var stageUpdate = await updateStage(customerId, updatedReferenceData);
			if (stageUpdate && stageUpdate.data) {
				getCustomer();
				toastRef.current.showToast({
					type: 'success',
					message: stageUpdate.data.message,
				});
			}
			setNewStageData(false)
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or Contact Admin.'
			});
		} finally {
			setLoading(false)
		}
	}

	const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

	return (
		<div>
			<ToastElement ref={toastRef} />
			<Loader loading={loading} />
			<div className="form-group row align-items-center mb-0 mt-0">
				<div className="col pr-0 pl-0">
					<div className="form-group row align-items-center mb-10">
						<div className="col-md-6 pl-0">
							<p className="label-text">
								{controlPanelTabs?.display_name}
							</p>
							<p className="group-table-text-section">
								Please input the Stage names you would like to use in your version of myConsole
							</p>
						</div>
						<div className="col pr-0 d-flex justify-end">
							{
								newStageData &&
								<ButtonElement className="save-button" type="button" label="Save" onClick={saveStages} />
							}
							<ButtonElement className="upload-button ml-3" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>

						</div>
					</div>
					<DataTable
						value={stage}
						columns={columns}
						dataKey="_id"
						isRowEditor={true}
						rowEditClick={rowEditClick}
					/>
				</div>
			</div>
			<div className="form-group row align-items-center mb-0 mt-0">
				<div className="col pr-0 pl-0">
					<div className="form-group row align-items-center mb-10">
						<div className="col-md-4 pl-0">
							<p className="label-text">
								Upload company image
							</p>
							<p className="group-table-text-section">
								Please upload an image for your company to use
							</p>
						</div>
						<div className="col pr-0 d-flex justify-end">
							<ButtonElement className="cancel-new-button" type="button" label="Return To Default" onClick={handlereturnToDefault} />
							<ButtonElement className="save-button" type="button" label="Save" onClick={handleUpload} />
						</div>
					</div>
					<div>
						{
							<div className="form-group row align-items-center mb-0 mt-0">
								<div className="col-md-3 pl-0">
									<p className='form-label text-left'>Select image to upload</p>
								</div>
								<div className="col-md-1 pl-0">
									<ButtonElement
										className="upload-button"
										type="button"
										icon="pi pi-upload"
										onClick={() =>
											setData()
										}
									/>
								</div>
								<div className="col-md-3 pl-0">
									<InputTextElementElement
										value={fileName}
										placeholder=""
										name="file_name"
										className="w-full"
										disabled
									/>
								</div>
							</div>
						}
						{
							<div className="form-group row align-items-center mb-0 mt-10">
								<div className="col-md-3 pl-0">
									<p className='form-label text-left'>Select color for the Surveys</p>
								</div>
								<div className="col-md-1 pl-0">
									<ColorPicker value={color} onChange={(e) => setColor(e.value)} defaultColor={colorDetails} />
								</div>
								<div className="col-md-3 pl-0">
									<InputTextElementElement
										value={(color != null && color != '') ? '#' + color : ''}
										placeholder=""
										name="color_name"
										className="w-full"
									/>
								</div>
							</div>
						}
					</div>
				</div>
			</div>
			<Dialog
				header={"Upload logo image"}
				visible={uploadPopup}
				position="top"
				onHide={onCloseUploadPopup}
				className="width-50vw"
				draggable={false}
			>
				<FileUploader
					handleSave={handleSave}
				/>
			</Dialog>
			<Dialog id="videoModal" visible={showVideo}
				breakpoints={{
				'1200px': '80vw',    // Larger modal on bigger screens
				'1024px': '85vw',    // Slightly smaller for medium screens
				'769': '90vw',     // Responsive on tablets
				'641px': '95vw',     // Almost full-width on mobile
				}}
				modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
			>
				<div className="video-overlay">
				<div className="video-container">
					<PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_setup" />
				</div>
				</div>
			</Dialog>
		</div>
	)
}

export default Setup;